import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import EditorialFrame, { type EditorialInjectedProps, type EditorialLayoutProps } from './EditorialFrame';

const EditorialQuoteContent: React.FC<EditorialInjectedProps & { content: any }> = ({ content, tokens, isStory }) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();

  return (
    <div
      style={{
        position: 'relative',
        padding: isStory ? '30px 0 26px' : '22px 0 18px',
        borderTop: `5px solid ${t.ink}`,
        borderBottom: `1px solid ${t.ink}`
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: isStory ? -12 : -9,
          left: isStory ? 18 : 14,
          padding: '0 9px',
          color: t.accent,
          background: t.paper,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 48 : 38),
          fontWeight: 700,
          lineHeight: 0.55
        }}
      >
        “
      </div>
      <blockquote
        style={{
          maxWidth: 280,
          margin: 0,
          color: t.ink,
          fontFamily: t.serif,
          fontSize: typeSize(isStory ? 31 : 25),
          fontWeight: 700,
          letterSpacing: '-0.6px',
          lineHeight: 1.34
        }}
      >
        {content.quote}
      </blockquote>
      {content.author ? (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '28px 1fr',
            gap: 11,
            alignItems: 'start',
            marginTop: isStory ? 28 : 21,
            color: t.muted,
            fontSize: typeSize(isStory ? 12.5 : 10.5),
            fontWeight: 700,
            letterSpacing: 0.6,
            lineHeight: 1.5,
            textTransform: 'uppercase'
          }}
        >
          <span style={{ height: 2, marginTop: 8, background: t.accent }} />
          <span>{content.author}</span>
        </div>
      ) : null}
    </div>
  );
};

const EditorialQuoteLayout: React.FC<EditorialLayoutProps> = props => (
  <EditorialFrame {...props}>
    <EditorialQuoteContent content={props.content || {}} />
  </EditorialFrame>
);

export default EditorialQuoteLayout;
